import { render, staticRenderFns } from "./loginTam.vue?vue&type=template&id=25c298b0&scoped=true&"
import script from "./loginTam.vue?vue&type=script&lang=js&"
export * from "./loginTam.vue?vue&type=script&lang=js&"
import style0 from "./loginTam.vue?vue&type=style&index=0&id=25c298b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c298b0",
  null
  
)

export default component.exports